const apiConfig = {
  api: {
    baseUrl: process.env.REACT_APP_API_URL,
    baseJavaUrl: process.env.REACT_APP_API_JAVA_URL,
    endpoints: {
      loginCheck: '/api/login_check',
      siteDevices: '/api/site_devices/:id',
      profile: '/api/current',
      dashboard: '/api/app/dashboard',
      battery: '/api/app/battery',
    },
    endpointsJava: {
      socAndBalancing: '/chart/socAndBalancing',
      powerAndBalancing: '/chart/powerAndBalancing',
      frequencyAndBalancing: '/chart/frequencyAndBalancing',
      revenue: '/chart/revenue',
      energy: '/chart/energy',
      ffrEnergyPrice: '/chart/ffr/energy/price',
      ffrCapacityPrice: '/chart/ffr/capacity/price',
      ffrEnergyVolumes: '/chart/ffr/energy/volumes',
      ffrCapacityVolumes: '/chart/ffr/capacity/volumes',
      battery: '/chart/battery',
      revenueTotal: '/chart/revenueTotal',
      revenueByMarket: '/chart/revenueByMarket',
      login: '/auth/login',
      sites: '/user/sites',
      profile: '/user/current',
    },
  },
  
};

export default apiConfig;
